import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";

interface TagMultiSelectProps {
  allTags: string[];
  value?: string[];
  onChange?: (value: string[]) => void;
}

export const TagMultiSelect = ({ allTags, value = [], onChange }: TagMultiSelectProps) => {
  const [query, setQuery] = useState("");
  const filtered = allTags.filter((t) => t.toLowerCase().includes(query.toLowerCase()) && !value.includes(t));
  const add = (t: string) => onChange?.([...value, t]);
  const remove = (t: string) => onChange?.(value.filter((v) => v !== t));

  return (
    <div className="space-y-2">
      <Input placeholder="Filter tags" value={query} onChange={(e) => setQuery(e.target.value)} />
      <div className="flex flex-wrap gap-2">
        {value.map((t) => (
          <Badge key={t} variant="secondary" className="cursor-pointer" onClick={() => remove(t)}>
            {t} ×
          </Badge>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {filtered.slice(0, 6).map((t) => (
          <Badge key={t} className="cursor-pointer" onClick={() => add(t)}>
            {t} +
          </Badge>
        ))}
      </div>
    </div>
  );
};
